import { put, select } from 'redux-saga/effects';
import _ from 'lodash';

import { selectChatAttachments } from '../../selectors';
import { setChatAttachments } from '../../actions';

// eslint-disable-next-line import/prefer-default-export
export function* addChatAttachment({ payload }) {
  const attachments = yield select(selectChatAttachments);
  const clonedAttachments = _.cloneDeep(attachments);
  const objectURL = window.URL.createObjectURL(payload.file);
  clonedAttachments[objectURL] = payload;

  yield put(setChatAttachments(clonedAttachments));
}
